import { render, staticRenderFns } from "./DatepickerOpenProgramatically.vue?vue&type=template&id=2480dd18&"
import script from "./DatepickerOpenProgramatically.vue?vue&type=script&lang=js&"
export * from "./DatepickerOpenProgramatically.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports